import Controller from './poi.controller';
import template from './poi.html';

const Component = {
    template,
    controller: ['$state', 'crConstants', 'crAnalyticsService', Controller],
};

export default Component;
